module.exports = "\r\n.form-group{\r\n    display: inline;\r\n}\r\n.float-right{\r\n    float: right;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/home/psa-criminal-proceedings-list/psa-criminal-proceedings-list.component.css
// module id = ./src/app/pages/home/psa-criminal-proceedings-list/psa-criminal-proceedings-list.component.css
// module chunks = main